import React from 'react';
import type { StatusFilter, PriorityFilter, IssueTypeFilter } from './useAdminTicketsPage';

type AdminTicketsFiltersProps = {
  statusFilter: StatusFilter;
  setStatusFilter: (s: StatusFilter) => void;
  priorityFilter: PriorityFilter;
  setPriorityFilter: (p: PriorityFilter) => void;
  issueTypeFilter: IssueTypeFilter;
  setIssueTypeFilter: (i: IssueTypeFilter) => void;
  getStatusCount: (status: string) => number;
  getPriorityCount: (priority: string) => number;
  getIssueTypeCount: (issueType: string) => number;
};

const STATUS_OPTIONS: StatusFilter[] = ['all', 'open', 'in_progress', 'resolved', 'closed'];
const PRIORITY_OPTIONS: PriorityFilter[] = ['all', 'low', 'medium', 'high', 'urgent'];
const ISSUE_TYPE_OPTIONS: IssueTypeFilter[] = ['all', 'credits', 'subscription', 'billing', 'technical', 'other'];

const AdminTicketsFilters: React.FC<AdminTicketsFiltersProps> = ({
  statusFilter,
  setStatusFilter,
  priorityFilter,
  setPriorityFilter,
  issueTypeFilter,
  setIssueTypeFilter,
  getStatusCount,
  getPriorityCount,
  getIssueTypeCount,
}) => (
  <div className="admin-tickets-filters">
    <div className="admin-tickets-filters-row">
      <div className="admin-tickets-filters-group">
        <span className="admin-tickets-filters-label">Status:</span>
        {STATUS_OPTIONS.map((status) => (
          <button
            key={status}
            type="button"
            onClick={() => setStatusFilter(status)}
            className={statusFilter === status ? 'admin-tickets-filter-btn active' : 'admin-tickets-filter-btn'}
          >
            {status.replace('_', ' ').charAt(0).toUpperCase() + status.replace('_', ' ').slice(1)} (
            {getStatusCount(status)})
          </button>
        ))}
      </div>
      <div className="admin-tickets-filters-group">
        <span className="admin-tickets-filters-label">Priority:</span>
        {PRIORITY_OPTIONS.map((priority) => (
          <button
            key={priority}
            type="button"
            onClick={() => setPriorityFilter(priority)}
            className={priorityFilter === priority ? 'admin-tickets-filter-btn active' : 'admin-tickets-filter-btn'}
          >
            {priority.charAt(0).toUpperCase() + priority.slice(1)} ({getPriorityCount(priority)})
          </button>
        ))}
      </div>
    </div>
    <div className="admin-tickets-filters-group admin-tickets-filters-row-2">
      <span className="admin-tickets-filters-label">Issue Type:</span>
      {ISSUE_TYPE_OPTIONS.map((issueType) => (
        <button
          key={issueType}
          type="button"
          onClick={() => setIssueTypeFilter(issueType)}
          className={issueTypeFilter === issueType ? 'admin-tickets-filter-btn active' : 'admin-tickets-filter-btn'}
        >
          {issueType.charAt(0).toUpperCase() + issueType.slice(1)} ({getIssueTypeCount(issueType)})
        </button>
      ))}
    </div>
  </div>
);

export default AdminTicketsFilters;
